import { Box } from '@mui/material';
import { FunctionComponent, useContext, useEffect } from 'react';
import { AppContext } from '../../../core/config';
import { useAppTranslate } from '../../../core/hooks';
import { NetworkServiceUpdateEvent } from '../../../l3-services/model';
import { Loader } from '../../../ui/components';
import { useL3ServiceStatusGroup } from '../../hooks';
import { DashboardCard } from '../DashboardCard/DashboardCard';
import { DashboardServiceStatusIcon } from '../DashboardServiceStatusIcon/DashboardServiceStatusIcon';

interface Props {
  statusUpdates: NetworkServiceUpdateEvent[];
}

export const DashboardServiceStatus: FunctionComponent<Props> = ({ statusUpdates }) => {
  const translate = useAppTranslate();
  const { customerId } = useContext(AppContext);
  const { data, isFetched, isFetching, refetch } = useL3ServiceStatusGroup(customerId);

  useEffect(() => {
    if (customerId !== null && !isFetching) {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusUpdates, refetch]);

  return <DashboardCard title={translate('cards.serviceStatus.title')}>
    {isFetching ? (<Loader loading={true} />) : null}
    {!isFetching && isFetched && data ? (
      <Box sx={{ display: 'flex', gap: '4rem' }}>
        {data.map((serviceStatusGroup) => <DashboardServiceStatusIcon
          key={serviceStatusGroup.status}
          serviceStatusGroup={serviceStatusGroup}
        />)}
      </Box>) : null}
  </DashboardCard>;
};